<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 v-if="vendedor._id" class>Editar Vendedor</h3>
              <h3 v-else>Novo Vendedor</h3>
            </div>
            <div class="col-auto">
              <b-button @click="$router.push({ name: 'EmpresaVendedor' })">Voltar</b-button>
            </div>
          </div>
        </div>
        <div class="element-box">
          <form @submit.prevent="save">
            <div class="form-row">
              <div class="col">
                <div class="form-group">
                  <b-form-checkbox switch
                      id="vendedorMaster"
                      v-model="isVendedorMaster"
                      name="vendedorMaster"
                      value="S"
                      unchecked-value="N"
                    >
                      Usuário master
                    </b-form-checkbox>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group" :class="{'has-danger': errors.has('name')}">
                  <label for="password">Nome</label>
                  <input
                    id="name"
                    name="name"
                    v-validate="'required'"
                    v-model="vendedor.name"
                    type="text"
                    class="form-control"
                  />
                  <div
                    v-if="errors.has('name')"
                    class="help-block form-text text-muted form-control-feedback"
                  >{{errors.first('name')}}</div>
                </div>
              </div>
              <div class="col">
                <div class="form-group" :class="{'has-danger': errors.has('cpf')}">
                  <label for="cpf">CPF</label>
                  <input
                    id="cpf"
                    name="cpf"
                    v-mask="'###.###.###-##'"
                    v-validate="'required|cpf'"
                    v-model="vendedor.cpf"
                    type="text"
                    class="form-control"
                  />
                  <div
                    v-if="errors.has('cpf')"
                    class="help-block form-text text-muted form-control-feedback"
                  >{{errors.first('cpf')}}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group" :class="{'has-danger': errors.has('email')}">
                  <label for="email">Email</label>
                  <input
                    id="email"
                    name="email"
                    v-validate="'required'"
                    v-model="vendedor.email"
                    type="text"
                    class="form-control"
                  />
                  <div
                    v-if="errors.has('email')"
                    class="help-block form-text text-muted form-control-feedback"
                  >{{errors.first('email')}}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group" :class="{'has-danger': errors.has('telefoneCelular')}">
                  <label>Telefone Celular</label>
                  <input type="text" class="form-control" 
                    id="telefoneCelular" name="telefoneCelular"
                    v-model="vendedor.telefoneCelular"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    v-validate="'required'">
                  <div
                    v-if="errors.has('telefoneCelular')"
                    class="help-block form-text text-muted form-control-feedback"
                  >{{errors.first('telefoneCelular')}}</div>
                </div>
              </div>
              <div class="col">
                <div class="form-group" :class="{'has-danger': errors.has('telefoneResidencial')}">
                  <label>Telefone Residencial</label>
                  <input type="text" class="form-control"
                    v-model="vendedor.telefoneFixo"
                    id="telefoneResidencial" name="telefoneResidencial" 
                    v-mask="['(##) ####-####', '(##) #####-####']">
                  <div
                    v-if="errors.has('telefoneResidencial')"
                    class="help-block form-text text-muted form-control-feedback"
                  >{{errors.first('telefoneResidencial')}}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3" v-if="empresa.pagarComissao === 'S' && !isVendedorMaster">
                <div class="form-group" :class="{'has-danger': errors.has('comissao')}">
                  <label for="comissao">Comissão</label>
                  <input
                    id="comissao"
                    name="comissao" min="0" max="100"
                    v-validate="'required|max_value:100|min_value:0'"
                    v-model="vendedor.comissaoVendedor"
                    type="number"
                    class="form-control"
                  />
                  <div
                      v-if="errors.has('comissao')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('comissao')}}</div>
                  </div>
                </div>
              </div>
            <div class="row">
              <div class="col">
                <div class="form-group" :class="{'has-danger': errors.has('username')}">
                  <label for="username">Username</label>
                  <input
                    id="username"
                    name="username"
                    v-validate="'required'"
                    v-model="vendedor.username"
                    type="text"
                    class="form-control"
                  />
                  <div
                    v-if="errors.has('username')"
                    class="help-block form-text text-muted form-control-feedback"
                  >{{errors.first('username')}}</div>
                </div>
              </div>
              <div class="col">
                <div class="form-group" :class="{'has-danger': errors.has('password')}">
                  <label for="password">Senha</label>
                  <input
                    id="password"
                    name="password"
                    v-validate="'required'"
                    v-model="vendedor.password"
                    type="text"
                    class="form-control"
                  />
                  <div
                    v-if="errors.has('password')"
                    class="help-block form-text text-muted form-control-feedback"
                  >{{errors.first('password')}}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                  <b-button variant="primary" type="submit">Salvar</b-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Validator } from "vee-validate";
import utils from "@/utils";

export default {
  computed: {
    empresa() {
      return this.$store.getters.empresa;
    },
    isAdministrador () {
      return this.$store.getters.isAdministrador;
    }
  },
  async created() {
    let id = this.$route.query.id;
    if (id) {
      const response = await axios.get(`/api/user/${id}`);
      this.vendedor = response.data;
      this.isVendedorMaster = this.vendedor.role === 'VendedorMaster' ? 'S' : 'N';
    }

    Validator.extend("cpf", {
      getMessage: () => "CPF inválido",
      validate: value => {
        return !!utils.TestaCPF(value);
      }
    });
  },
  data() {
    return {
      vendedor: {},
      isVendedorMaster: null
    };
  },
  methods: {
      save() {
          this.$validator.validateAll()
          .then(async (result) => {
              if (result) {
                  this.vendedor.juridica = this.empresa;
                  this.vendedor.status = 'Habilitado';

                  if (this.isVendedorMaster === 'S') {
                    this.vendedor.role = 'VendedorMaster';
                  } else {
                    this.vendedor.role = 'Vendedor';
                  }
                  
                  try {
                    if (this.vendedor._id) {
                      await axios.put('/api/user/' + this.vendedor._id, this.vendedor);
                    } else {
                      await axios.post('/api/user', this.vendedor);
                    }
                    this.$router.push({name: 'EmpresaVendedor'});
                  } catch (error) {
                    if (error.response.data.code === 11000) {
                      this.$bvModal.msgBoxOk('O nome de usuário já está em uso!',{
                        title: 'Falha ao salvar usuário',
                        centered: true,
                        buttonSize: 'sm',
                        okVariant: 'success',
                        'bodyTextVariant': 'danger',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                      });
                    }
                  }

              }
          });
      }
  }
};
</script>
